import iClinicApi from 'services/iclinic/iClinicApi';
import { SubscribeData, VoucherData } from './types';

export const getPlans = () => iClinicApi.get(`/products/products-checkout/`);

export const getPhysiciansByClinic = (clinicId: number) =>
  iClinicApi.get(`/clinics/clinic/physicians-by-clinic/${clinicId}`);

export const postSubscribe = (subscribeData: SubscribeData) =>
  iClinicApi.post('/subscriptions/subscription/subscribe/', subscribeData);

export const postApplyVoucher = (voucherData: VoucherData) =>
  iClinicApi.post(
    '/subscriptions/voucher/set-subscription-to-voucher/',
    voucherData,
  );

export const postRemoveVoucher = (voucherData: VoucherData) =>
  iClinicApi.post(
    '/subscriptions/voucher/remove-subscription-from-voucher/',
    voucherData,
  );
